import { createContext, useContext, useEffect, useState } from "react";
import {
  adminApi,
  adminLogin,
  clearSession,
  getStoredAdmin,
  getToken,
} from "./adminApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => (getToken() ? getStoredAdmin() : null));
  const [booting, setBooting] = useState(Boolean(getToken()));

  useEffect(() => {
    if (!getToken()) {
      setBooting(false);
      return;
    }
    adminApi
      .get("/admin/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        clearSession();
        setAdmin(null);
      })
      .finally(() => setBooting(false));
  }, []);

  const login = async (email, password) => {
    const a = await adminLogin(email, password);
    setAdmin(a);
    return a;
  };

  const logout = () => {
    clearSession();
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, booting, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
